import { render } from "./PaymentsPaid.vue?vue&type=template&id=de541588&scoped=true"
import script from "./PaymentsPaid.vue?vue&type=script&lang=js"
export * from "./PaymentsPaid.vue?vue&type=script&lang=js"

import "./PaymentsPaid.vue?vue&type=style&index=0&id=de541588&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de541588"]])

export default __exports__